export const globalStyles = {
    desktop: {
        pageMargin: '5rem',
    },
    mobile: {
        pageMargin: '1rem',
    },
    breakpoints: {
        small: '600px',
        medium: '768px',
        large: '992px',
        xlarge: '1200px'
    }
}